import { useEffect } from 'react'

export const useClickOnMask = (callback: () => void) =>
  useEffect(() => {
    const handleClickOutside = ({ target }: MouseEvent) => {
      if (!(target instanceof HTMLElement)) return

      if (target.classList.contains('modal-mask')) {
        callback()
        return
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [callback])
